module.exports = __webpack_public_path__ + "img/icon_community.938a2cd2.svg";